import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaClock, FaTwitter, FaFacebook, FaInstagram } from 'react-icons/fa';

const Footer = () => {
    return (
        <footer className="footer py-5 bg-dark text-white">
            <Container>
                <Row>
                    <Col lg={3} md={6} className="mb-4 mb-lg-0">
                        <img src="/logo_footer.png" alt="Otoprime Logo" height="60" className="mb-4" />
                        <p>Alternatif araç finansman çözümleri sunan Türkiye'nin lider platformu. 2020'den beri hizmet vermekteyiz.</p>
                        <p className="mb-3">© 2025 Otoprime. Tüm hakları saklıdır.</p>
                        <div className="mb-3">
                            <p className="mb-2">Bizi Takip Edin</p>
                            <div className="d-flex gap-3">
                            
                                <a href="https://www.facebook.com/profile.php?id=61576631722377" target="_blank" rel="noopener noreferrer" className="text-white footer-social-link">
                                    <FaFacebook size={20} />
                                </a>
                                <a href="https://www.instagram.com/otoprimetaksit/" target="_blank" rel="noopener noreferrer" className="text-white footer-social-link">
                                    <FaInstagram size={20} />
                                </a>
                            </div>
                        </div>
                    </Col>
                    <Col lg={3} md={6} className="mb-4 mb-lg-0">
                        <h5 className="mb-4">Hızlı Erişim</h5>
                        <ul className="list-unstyled">
                            <li className="mb-2"><Link to="/sales-system" className="footer-link">Satış Sistemi</Link></li>
                            <li className="mb-2"><Link to="/about" className="footer-link">Hakkımızda</Link></li>
                            <li className="mb-2"><Link to="/contact" className="footer-link">İletişim</Link></li>
                            <li className="mb-2"><Link to="/faq" className="footer-link">Sık Sorulan Sorular</Link></li>
                        </ul>
                    </Col>
                    <Col lg={3} md={6} className="mb-4 mb-lg-0">
                        <h5 className="mb-4">İletişim</h5>
                        <ul className="list-unstyled">
                            <li className="mb-2 d-flex align-items-center">
                                <FaMapMarkerAlt className="me-2 footer-icon" />
                                <span>Kaynarca Mah. Zirve Sok., Optimum Modern Sitesi No:1, 34890 Pendik/İstanbul</span>
                            </li>
                            <li className="mb-2 d-flex align-items-center">
                                <FaPhoneAlt className="me-2 footer-icon" />
                                <span>+90 (532) 387 30 91</span>
                            </li>
                            <li className="mb-2 d-flex align-items-center">
                                <FaEnvelope className="me-2 footer-icon" />
                                <span>iletisim@otoprimetaksit.com</span>
                            </li>
                            <li className="mb-2 d-flex align-items-center">
                                <FaClock className="me-2 footer-icon" />
                                <span>Pazartesi - Cumartesi: 09:00 - 18:00</span>
                            </li>
                        </ul>
                    </Col>
                    <Col lg={3} md={6}>
                        <h5 className="mb-4">Bilgilendirme</h5>
                        <ul className="list-unstyled">
                            <li className="mb-2"><Link to="/cerez-politikasi" className="footer-link">Çerez Politikası</Link></li>
                            <li className="mb-2"><Link to="/kvkk-aydinlatma-formu" className="footer-link">KVKK Aydınlatma Formu</Link></li>
                        </ul>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
};

export default Footer;